module.exports = __webpack_public_path__ + "public/images/slider/loseva.39a5c0703d2f670341e4d64dfbd9aaa8.webp";